<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Move Size chart link to Size chart start
const interval = setInterval(() => {
    const targetDivs = document.querySelectorAll('div[data-unique="_wftq5137k"]');
    const movingDiv = document.querySelector('.productView-sizeChart');

    if (!movingDiv) {
       // console.log("Waiting for .productView-sizeChart...");
        return;
    }

    targetDivs.forEach(targetDiv => {
        const labelElement = Array.from(targetDiv.querySelectorAll('label'))
            .find(label => label.querySelector('span')?.textContent.trim() === "STANDARD SIZE:");

        if (labelElement) {
            //console.log("Found target label! Moving .productView-sizeChart...");
            labelElement.insertAdjacentElement('afterend', movingDiv);
            clearInterval(interval); // Stop checking once moved
        }
    });
}, 500); 

/////////////////////////

/*
const moveSizeGuide = setInterval(() => {
    const allLabels = document.querySelectorAll('.bcpo-label label');

    allLabels.forEach(label => {
        const titleSpan = label.querySelector('.bcpo-title');
        const isStandardSize = titleSpan && titleSpan.textContent.trim().toUpperCase() === 'STANDARD SIZE:';

        if (isStandardSize) {
            const perks = document.querySelector('.productView-perks');
            const bcpoLabel = label.closest('.bcpo-label');

            // Ensure element exists and hasn't already been moved
            if (perks && bcpoLabel && !bcpoLabel.contains(perks)) {
                label.insertAdjacentElement('afterend', perks);
                clearInterval(moveSizeGuide); // Move only once
            }
        }
    });
}, 300);
*/

const moveSizeGuide = setInterval(() => {
    const allLabels = document.querySelectorAll('.bcpo-label label');

    allLabels.forEach(label => {
        const titleSpan = label.querySelector('.bcpo-title');
        const isStandardSize = titleSpan && titleSpan.textContent.trim().toUpperCase() === 'STANDARD SIZE:';

        if (isStandardSize) {
            const perks = document.querySelector('.productView-perks');
            const bcpoLabel = label.closest('.bcpo-label');

            if (perks && bcpoLabel && !bcpoLabel.contains(perks)) {
                // Move the element
                label.insertAdjacentElement('afterend', perks);

                // Apply CSS styles
                perks.style.float = 'right';
                perks.style.marginRight = '10px';

                clearInterval(moveSizeGuide); // Stop after successful move
            }
        }
    });
}, 300);


//////////////////////////

// Move Size chart link to Size chart End

document.addEventListener("DOMContentLoaded", function () {
  // Only run the accordion logic if screen width >= 551px
  if (window.innerWidth >= 551) {

    setTimeout(function() {
      document.querySelectorAll("a.tab-title").forEach(function(el) {
        if (el.style.getPropertyValue("--border-color")) {
          el.style.removeProperty("--border-color");
        }
      });
    }, 200);


    var tabsContainer = document.querySelector(".tabs");
    if (!tabsContainer) return;

    // Get all tab <li> items
    var tabItems = tabsContainer.querySelectorAll("li.tab");

    // Move associated content after each tab & set up classes
    tabItems.forEach(function (tab) {
      var link = tab.querySelector("a.tab-title");
      if (link) {
        var contentId = link.getAttribute("href"); // e.g. "#tab-product-details"
        var contentDiv = document.querySelector(contentId);
        if (contentDiv) {
          // Move the contentDiv after the tab
          tab.insertAdjacentElement("afterend", contentDiv);
          // Remove conflicting classes
          contentDiv.classList.remove("is-active", "active");
          // Add our custom class
          contentDiv.classList.add("my-tab-content");
          // Hide initially
          contentDiv.classList.remove("visible");
        }
      }
    });

    // Accordion click events
    tabItems.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var contentDiv = tab.nextElementSibling;
        if (contentDiv && contentDiv.classList.contains("my-tab-content")) {
          if (contentDiv.classList.contains("visible")) {
            // Collapse if open
            contentDiv.classList.remove("visible");
            tab.classList.remove("active");
          } else {
            // Collapse all panels first
            document.querySelectorAll(".my-tab-content").forEach(function (div) {
              div.classList.remove("visible");
            });
            tabItems.forEach(function (t) {
              t.classList.remove("active");
            });
            // Expand the clicked tab’s content
            contentDiv.classList.add("visible");
            tab.classList.add("active");
          }
        }
      });
    });
  }
});




